import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'does_facility_require_other_infection_illness_tests_e_2'

export const dataPointDefinition = {
  retracedId: 'does_facility_require_other_infection_illness_tests_e_2',
  name: 'Does the facility require other infection or illness tests (e.g. Hepatitis B) during employment?',
  description: 'You have indicated that there are "No applicable legal requirements". ',
  meta: {
    slcpMeta: {
      key: 'wt-dis-51',
      number: 'WT-DIS-24',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wt-dis-51', version: '1.7.0', provider: 'slcp'}],
  sortingId: 37420,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
